import type { CSSProperties } from 'react';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  circle?: boolean;
  radius?: string;
}

/**
 * A shimmering placeholder block.
 *
 * Used instead of "Loading…" wherever the shape of what is coming is already
 * known, so the layout does not jump when the data lands.
 */
export function Skeleton({ width, height = 12, circle = false, radius }: SkeletonProps) {
  const style: CSSProperties = { width, height };

  if (radius) {
    style.borderRadius = radius;
  }

  return (
    <span
      className={circle ? 'skeleton skeleton--circle' : 'skeleton'}
      style={style}
      aria-hidden="true"
    />
  );
}
